import React from "react";
import { FaLinkedin, FaEnvelope, FaGithub, FaInstagram } from "react-icons/fa";

const Footer = () => {
    return (
    <div className="container">
        <footer className="footer">       
            <p className="mb-0">Copyright 2025 &copy; TEHZEEB JAHAN</p>
            <div className="social-links text-right m-auto ml-sm-auto">
                <a 
                    href="https://github.com/tehzeeb2487" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link"
                >
                    <FaGithub className="footer-icon" />
                </a>
                <a 
                    href="https://www.linkedin.com/in/tehzeeb-jahan-966792342" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link"
                >
                    <FaLinkedin className="footer-icon" />
                </a>
                <a 
                    href="mailto:javedshikh312@gmail.com" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="link"
                >
                    <FaEnvelope className="footer-icon" />
                </a>
                <a
                    href="https://www.instagram.com/tehzeeb.dev/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                >
                    <FaInstagram className="footer-icon" />
                </a>
            </div>
        </footer>
    </div>
    );
}

export default Footer ;